import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_SERVER_URL
})

export const maintenanceAxios = axios.create({
  // キャッシュに保存しない
  headers: {'Cache-Control': 'no-store'}
})

// スラッシュを強制的に付与する
// APIサーバーへのリクエストには必須なため
// instance.interceptors.request.use((config) => {
//   if (config.url[config.url.length-1] !== '/') {
//     config.url += '/'
//   }
//   return config
// })

const install = (Vue, options) => {
  instance.defaults.headers.Authorization = options.initialToken !== null ? `jwt ${options.initialToken}` : null
  instance.defaults.baseURL = options.apiUrl? options.apiUrl :process.env.VUE_APP_API_SERVER_URL

  instance.interceptors.response.use(null, error => {
    if (!!error.response && error.response.status === 401) {
      console.error('401エラーによりリクエスト失敗しました.')
      options.authErrorCb()
    }
  
    return Promise.reject(error)
  })
  Vue.prototype.$axios = instance
}

export default {
  install
}